import { get, getDatabase, ref, set } from 'firebase/database';
import { getAuth } from 'firebase/auth';
import { recordActivity } from './activityApi';
import { CustomerType, CUSTOMER_TYPE_PATH, parseCustomerType } from '../types/customerType';

/**
 * Read `global/customerType` once per app session and keep the result.
 *
 * The value changes extremely rarely (set once when the instance is created),
 * so there is no subscription: a page reload after changing it is fine.
 * `setCustomerType` clears the cached value so the superadmin page reflects
 * the change without a reload.
 */
let cached: Promise<CustomerType | null> | null = null;

export function getCustomerType(): Promise<CustomerType | null> {
    if (!cached) {
        cached = get(ref(getDatabase(), CUSTOMER_TYPE_PATH))
            .then(snapshot => parseCustomerType(snapshot.val()))
            .catch(err => {
                console.error('Failed to read customer type', err);
                cached = null;
                return null;
            });
    }
    return cached;
}

export async function setCustomerType(type: CustomerType): Promise<void> {
    const auth = getAuth();
    if (!auth.currentUser) {
        throw new Error('Du måste vara inloggad för att ändra kundtyp');
    }

    try {
        await set(ref(getDatabase(), CUSTOMER_TYPE_PATH), type);
        cached = Promise.resolve(type);
    } catch (err) {
        console.error('Failed to save customer type', err);
        throw new Error('Kunde inte spara kundtypen. Försök igen.');
    }
    recordActivity('settings.updated');
}
